import { __read, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { useState, useRef } from 'react';
import { Root as $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, Trigger as $cb5cc270b50c6fcd$export$41fb9f06171c75f4, Portal as $cb5cc270b50c6fcd$export$602eac185826482c, Content as $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, Arrow as $cb5cc270b50c6fcd$export$21b07c8f274aebd5 } from './../../external_lib/@radix-ui/react-popover/dist/index.js';
import styles from '../../components/helpers/popover/popover.module.scss.js';
function Popover(_a) {
  var content = _a.content,
    children = _a.children,
    contentWidth = _a.contentWidth,
    _b = _a.contentSide,
    contentSide = _b === void 0 ? 'bottom' : _b,
    _c = _a.closeOnContentClick,
    closeOnContentClick = _c === void 0 ? false : _c,
    _d = _a.popoverContentProps,
    popoverContentProps = _d === void 0 ? {} : _d,
    _e = _a.hideArrow,
    hideArrow = _e === void 0 ? false : _e;
  var _f = __read(useState(false), 2),
    open = _f[0],
    setOpen = _f[1];
  var ref = useRef();
  var handleMouseEnter = function () {
    if (!content) {
      return;
    }
    if (ref.current) {
      clearTimeout(ref.current);
    }
    setOpen(true);
  };
  var handleMouseLeave = function () {
    if (!content) {
      return;
    }
    ref.current = setTimeout(function () {
      setOpen(false);
    }, 200);
  };
  var handleContentClick = function () {
    if (closeOnContentClick) {
      setOpen(false);
    }
  };
  return React__default.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, {
    open: open,
    onOpenChange: setOpen
  }, React__default.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, {
    asChild: true,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, React__default.createElement("span", {
    className: "py-1"
  }, children)), React__default.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, React__default.createElement($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, __assign({
    align: "start",
    avoidCollisions: true,
    side: contentSide,
    collisionPadding: 20,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    className: styles.popoverContent,
    style: {
      width: contentWidth
    }
  }, popoverContentProps), React__default.createElement("div", {
    onClick: handleContentClick,
    className: styles.popoverContentWrapper
  }, content), !hideArrow && React__default.createElement($cb5cc270b50c6fcd$export$21b07c8f274aebd5, {
    className: styles.popoverArrow,
    width: 12,
    height: 10
  }))));
}
export { Popover as default };
//# sourceMappingURL=index.js.map
